import styled from '@emotion/styled';

export const StyledHeading = styled.h3`
    font-size: ${(props) => props.theme.fontSize.headlineM};
`;

export const StyledDeckPlanContainer = styled.section`
    color: ${(props) => props.theme.colorsUnifications.gunmetal['100']};
`;
